/* 🤖 this file was generated by svg-to-ts*/
export const icoCloud: {
  name: 'cloud';
  data: string;
} = {
  name: 'cloud',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.755 5.005a6.003 6.003 0 00-5.37 3.877l-.059.164-.207.034A5.002 5.002 0 002 14a5 5 0 005 5h10.5a4.5 4.5 0 004.5-4.5l-.005-.212a4.502 4.502 0 00-4.079-4.269l-.023-.135A6.002 6.002 0 0012 5l-.245.005z" fill="#909090"/></svg>`
};
